module.exports = __webpack_public_path__ + "static/media/geometric.527933ce.png";